export default __webpack_public_path__ + "static/media/arrow__right-red.f30cc5e7.svg";